import escapeRegExp from 'lodash/escapeRegExp';

export type EmailValidation = { isValid: boolean; isValidEmail: boolean; isValidDomain: boolean };

export function validateEmail(email: unknown, domainRegex?: string): EmailValidation {
  // eslint-disable-next-line no-useless-escape
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValidEmail = re.test(String(email).toLowerCase());
  const isValidDomain = isEmailDomainRegexCompliant(email, domainRegex);
  return { isValid: isValidEmail && isValidDomain, isValidEmail, isValidDomain };
}

export function isEmailDomainRegexCompliant(email: unknown, domainRegex?: string): boolean {
  if (!email) return false;
  if (!domainRegex) return true;
  const isMatching = new RegExp(domainRegex, 'i').test(email as string);
  return isMatching;
}

const isLetter = new RegExp(/[a-zA-Z]/);

export function makeCaseInsensitive(regex: string): string {
  return regex
    .split('')
    .map((letter) => {
      if (isLetter.test(letter)) {
        return `[${letter.toLowerCase()}${letter.toUpperCase()}]`;
      }
      return letter;
    })
    .join('');
}

/**
 * Regex (string, usable as an HTML `pattern`) accepting only whitelisted domains,
 * or rejecting blacklisted ones. `undefined` when there is no restriction.
 */
export function getEmailDomainRegex({ whitelist = [], blacklist = [] }: { whitelist?: string[]; blacklist?: string[] }): string | undefined {
  if (!whitelist.length && !blacklist.length) return;
  return whitelist.length
    ? `^.*@(${whitelist.map((d) => `(${makeCaseInsensitive(escapeRegExp(d))})`).join('|')})$`
    : `^.*@(${blacklist.map((d) => `(?!${makeCaseInsensitive(escapeRegExp(d))})`).join('')}.)*$`;
}

type DomainList = { domains?: string[] } | null | undefined;

/** Domain regex of an EmailField, from its `whitelist` / `blacklist` settings. */
export function getEmailFieldDomainRegex(field: { whitelist?: DomainList; blacklist?: DomainList }): string | undefined {
  const { whitelist = {}, blacklist = {} } = field;
  const { domains: whitelistedDomains } = whitelist || {};
  const { domains: blacklistedDomains } = blacklist || {};
  return getEmailDomainRegex({ whitelist: whitelistedDomains, blacklist: blacklistedDomains });
}
